export const FETCH_STUDENTS = "FETCH_STUDENTS";
export const FETCH_STUDENTS_SUCCESS = "FETCH_STUDENTS_SUCCESS";
export const FETCH_STUDENTS_FAIL = "FETCH_STUDENTS_FAIL";
export const ADD_STUDENT_SUCCESS = "ADD_STUDENT_SUCCESS";
export const ADD_STUDENT_FAIL = "ADD_STUDENT_FAIL"; 
export const DELETE_STUDENT = "DELETE_STUDENT";
export const FETCH_STUDENT = "FETCH_STUDENT";
export const FETCH_STUDENT_SUCCESS = "FETCH_STUDENT_SUCCESS";
export const FETCH_STUDENT_FAIL = "FETCH_STUDENT_FAIL";
export const UPDATE_STUDENT_SUCCESS = "UPDATE_STUDENT_SUCCESS";
export const UPDATE_STUDENT_FAIL = "UPDATE_STUDENT_FAIL";